<template>
  <div class="iframe-detail">
    <div class="container" v-if="place">
      <div class="status" :class="statusClass(place.status)">
        <p>[{{ statusDetailHeader(place.status, place.is_nodata) }}]&nbsp;{{ statusDetailLabel(place.status, place.is_nodata) }}</p>
      </div>
      <div class="notice">
        <p>※店舗近辺の推定混雑状況です。</p>
      </div>
      <div class="chart">
        <div class="chart-inner">
          <Chart :height="253"/>
        </div>
      </div>
      <div class="last-update">
        <p>最終更新 : {{ lastUpdateDateTime }}</p>
      </div>
      <div class="site-link">
        <img src="@/assets/images/favicon.png">
        <a :href="'/detail/'+place.code" target="_blank">お買物混雑マップで見る</a>
      </div>
    </div>
    <div v-if="notFound" class="not-found">
      <div class="elements">
        <img src="@/assets/images/noun-alert.svg">
        <p>お買物混雑マップへの<br>店舗登録がありません</p>
        <div class="site-link">
          <img src="@/assets/images/favicon.png">
          <a href="/" target="_blank">お買物混雑マップTOPへ</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapGetters, mapState } from 'vuex'
import Chart from '@/components/Chart.vue'
import statusHelper from '@/lib/StatusHelper.js'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Detail',
  components: {
    Chart,
  },
  computed: {
    ...mapGetters(['lastUpdateDateTime']),
    ...mapState(['place', 'notFound']),
  },
  methods: {
    statusClass: statusHelper.statusClass,
    statusDetailLabel: statusHelper.statusDetailLabel,
    statusDetailHeader: statusHelper.statusDetailHeader,
  }
})
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  background-color: #fff;
  padding: 15px 0 17px;

  .status {
    margin: 0 15px;
    text-align: center;

    p {
      margin: 0;
      line-height: 43px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
    }

    &.is-status-0 {
      background-color: #fff;
      border: 1px solid #CCCCCC;
      p {
        color: #333333;
        line-height: 41px;
      }
    }
    &.is-status-1 {
      background-color: #4AB2F2;
    }
    &.is-status-2 {
      background-color: #9DB41D;
    }
    &.is-status-3 {
      background-color: #D61A1A;
    }
  }

  .notice {
    p {
      margin: 9px 0 0;
      color: #D13E3E;
      font-size: 13px;
      text-align: center;
    }
  }

  .chart {
    font-family: "Hiragino Kaku Gothic ProN", "Yu Gothic", YuGothic, Verdana, Meiryo, sans-serif;
    overflow: hidden;

    &-inner {
      margin-top: 0px;
      margin-left: 0px;
      margin-right: -5px;
    }
  }

  .last-update {
    text-align: center;
    margin-top: -19px;

    p {
      margin: 0;
      color: #999999;
      font-size: 13px;
    }
  }

  .site-link {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 16px;
      height: 16px;
    }

    a {
      margin-left: 4px;
      color: #141430;
      font-size: 13px;
      font-weight: bold;
    }
  }
}

.not-found {
  position: relative;
  height: 390px;

  .elements {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto; 
    width: 200px;
    height: 145px;
    text-align: center;

    img {
      width: 55px;
      height: 61px;
    }

    p {
      margin: 10px 0 0;
      line-height: 22px;
      font-size: 14px;
      font-weight: bold;
      color: #999999;
    }

    .site-link {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 16px;
        height: 16px;
      }

      a {
        margin-left: 4px;
        color: #141430;
        font-size: 13px;
        font-weight: bold;
      }
    }
  }
}

@media screen and (max-width: 374px) {
  .container {
    .status {
      p {
        font-size: 14px;
      }
    }
  }
}
</style>

<style lang="scss">
.iframe-detail {
  .apexcharts-legend  {
    justify-content: center !important;
    padding: 0 21px 0 15px !important;
    margin: 0 !important;
    bottom: 14px !important;

    .apexcharts-legend-text {
      font-size: 13px !important;
    }
  }
}
</style>
